import { useState, useEffect, RefObject } from "react";

export const useWindowHeight = (ref?: RefObject<HTMLDivElement>) => {
  const calcHeight = () => {
    if (ref && ref.current) {
      const offsetTop = ref.current.offsetTop;
      const heightToSet = window.innerHeight - offsetTop - 80; // 80 is an adjustment for the parent container

      setWindowHeight(heightToSet);
    }
  };

  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    calcHeight();

    const handleResize = () => {
      calcHeight();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref]);

  return windowHeight;
};
